import React from 'react';
import { Episode } from '../../types/types';

interface MobileRecentEpisodeProps {
  episode: Episode;
}

const MobileRecentEpisode: React.FC<MobileRecentEpisodeProps> = ({ episode }) => {
  const videoContainerStyle: React.CSSProperties = {
    position: 'relative',
    width: '100%',
    paddingTop: '56.25%', // 16:9 aspect ratio
    backgroundColor: '#000',
    borderRadius: '15px 15px 0 0',
    overflow: 'hidden'
  };

  const iframeStyle: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: 'none'
  };

  const cardStyle: React.CSSProperties = {
    backgroundColor: '#1a1a1a',
    borderRadius: '15px',
    overflow: 'hidden',
    margin: '0 auto',
    maxWidth: '600px',
    width: '100%'
  };

  const descriptionStyle: React.CSSProperties = {
    color: '#ccc',
    fontSize: '0.95rem',
    lineHeight: 1.6,
    padding: '1.5rem',
    borderTop: '1px solid rgba(255, 255, 255, 0.1)'
  };

  const paragraphStyle: React.CSSProperties = {
    marginBottom: '1rem'
  };

  const renderDescription = (description: string) => {
    return description.split('\n').map((paragraph, index) => (
      paragraph.trim() && (
        <p key={index} style={paragraphStyle}>
          {paragraph}
        </p>
      )
    ));
  };

  return (
    <div className="mobile-latest-episode" style={{ padding: '1rem' }}>
      <h2 style={{ 
        color: '#fff', 
        textAlign: 'center', 
        marginBottom: '1.5rem',
        fontSize: '1.5rem'
      }}>
        LATEST EPISODE
      </h2>
      <div style={cardStyle}>
        <div style={videoContainerStyle}>
          <iframe
            src={`https://www.youtube.com/embed/${episode.videoId}`}
            title={episode.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={iframeStyle}
          />
        </div>
        <div style={{ padding: '1.5rem' }}>
          <span style={{
            color: '#FF6B39',
            fontSize: '0.9rem',
            fontWeight: 600,
            display: 'inline-block',
            padding: '0.4rem 1rem',
            backgroundColor: 'rgba(255, 107, 57, 0.1)',
            borderRadius: '20px',
            marginBottom: '1rem'
          }}>
            {episode.number}
          </span>
          <h3 style={{
            color: '#FFFFFF',
            fontSize: '1.2rem',
            lineHeight: 1.4,
            marginBottom: '1rem',
            fontWeight: 600
          }}>
            {episode.title}
          </h3>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '2rem',
            color: '#888',
            fontSize: '0.8rem',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }}>
            <time dateTime={episode.date}>
              {new Date(episode.date).toLocaleDateString('en-US', { 
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </time>
            <span>{episode.duration}</span>
          </div>
        </div>
        {episode.description && (
          <div style={descriptionStyle}>
            {renderDescription(episode.description)}
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileRecentEpisode; 